import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Button, FormControl, Input, InputLabel } from '@mui/material';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { Props } from './interface';
import {
  getUserAsync,
  updateUserBalanceAsync
} from '../../redux/slices/usersSlice';
import { InputChangeEvent } from '../../resources/utils';
import BalanceConfirmationModal from './BalanceConfirmationModal';

const PREFIX = 'UserBalance';

const classes = {
  wrapper: `${PREFIX}-wrapper`,
  submit: `${PREFIX}-submit`,
  balance: `${PREFIX}-balance`,
  negative: `${PREFIX}-negative`
};

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`& .${classes.wrapper}`]: {
    display: 'inline-flex',
    alignItems: 'flex-end'
  },

  [`& .${classes.submit}`]: {
    marginLeft: 20
  },

  [`& .${classes.balance}`]: {
    fontWeight: 600,
    color: theme.palette.primary.main
  },

  [`& .${classes.negative}`]: {
    color: theme.palette.error.main
  }
}));

const UserBalance = ({ balance, margin, fullWidth, userId, onSave }: Props) => {
  const dispatch = useDispatch();

  const [value, setValue] = useState('');
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const handleOpenConfirmModal = () => {
    if (!value || Number(value) === 0) return;
    setConfirmModalOpen(true);
  };

  const handleConfirm = (description: string) => {
    dispatch(
      updateUserBalanceAsync(
        userId,
        { 
          amount: Number(value),
          description: description || undefined
        },
        () => {
          dispatch(getUserAsync(userId));

          if (onSave) {
            onSave();
          }

          setValue('');
        }
      )
    );
  };

  const isNegative = Number(value) < 0;

  return (
    <>
      <StyledFormControl fullWidth={fullWidth} margin={margin}>
        <div className={classes.wrapper}>
          <FormControl fullWidth>
            <InputLabel>
              Баланс (
              <span
                className={clsx(classes.balance, balance < 0 && classes.negative)}
              >
                {balance}
              </span>
              )
            </InputLabel>
            <Input
              fullWidth={fullWidth}
              margin='none'
              type='number'
              value={value}
              onChange={(e: InputChangeEvent) => setValue(e.target.value)}
            />
          </FormControl>
          <Button 
            className={classes.submit} 
            color={isNegative ? 'error' : 'primary'} 
            variant={isNegative ? 'contained' : 'text'}
            onClick={handleOpenConfirmModal}
          >
            {isNegative ? 'Відняти' : 'Додати'}
          </Button>
        </div>
        <div />
      </StyledFormControl>

      <BalanceConfirmationModal
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={handleConfirm}
        amount={Number(value)}
        currentBalance={balance}
      />
    </>
  );
};

export default UserBalance;
